exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_mediaFileSelectorPanel_1AcpJZu33I8sU9fH8uAf2K {\n  position: relative;\n  width: 100%;\n  float: left;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.IA_tagButton_2YFm07Ul7RaWe7tYAcNN9 {\n  padding: 5px 7px;\n  margin: 5px;\n  border-radius: 5px;\n  cursor: pointer;\n  user-select: none;\n  display: inline-block;\n  font-size: 13px;\n}", ""]);

// Exports
exports.locals = {
	"IA_mediaFileSelectorPanel": "IA_mediaFileSelectorPanel_1AcpJZu33I8sU9fH8uAf2K",
	"IA_tagButton": "IA_tagButton_2YFm07Ul7RaWe7tYAcNN9"
};